import { render } from "./HCPatientDetails.vue?vue&type=template&id=7585ec8c"
import script from "./HCPatientDetails.ts?vue&type=script&lang=js&external"
export * from "./HCPatientDetails.ts?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__